import React from "react";
import styled from "styled-components";
import Link from "src/core/common/components/modules/Link";
import {ChevronRight} from "@styled-icons/boxicons-solid/ChevronRight";
import {useMediaQuery} from "react-responsive";

function ViewAllLink({to, keepQuery, accessibilityIdentifier, ...props}) {
  const isDesktop = useMediaQuery({minWidth: 1025});

  return (
    <CustomLink
      aria-label={`See all ${
        to && to.params ? to.params.category : `category ${accessibilityIdentifier}`
      } products`}
      to={to}
      keepQuery={keepQuery}
      color={props.color}
      underlined={
        props.underlined !== undefined ? props.underlined : props.defaultUnderlined
      }
    >
      <ViewAllText color={props.color}>
        <span>{isDesktop ? "See All" : ""}</span>
        <ChevronRightIcon
          color={props.color}
          role="img"
          title="See all"
          aria-label={`See all ${
            to && to.params ? to.params.category : `category ${accessibilityIdentifier}`
          } products`}
        />
      </ViewAllText>
    </CustomLink>
  );
}

const CustomLink = styled(Link)`
  text-decoration: ${({underlined}) =>
    underlined ? "underline !important" : "none !important"};
  text-decoration-color: ${({color}) => `${color} !important`};
`;

const ViewAllText = styled.span`
  display: flex;
  font-size: ${({theme}) => theme.v2.typography.sizing.l.lg};
  color: ${({theme, color}) => (color ? color : theme.v2.color.onSurface)};
  font-weight: ${({theme}) => theme.v2.typography.body.weight.heavy};
  align-items: center;
  white-space: nowrap;
`;

const ChevronRightIcon = styled(ChevronRight)`
  color: ${({theme, color}) => (color ? color : "#fff")};
  background-color: ${({theme, color}) => (color ? color : theme.v2.color.onSurface)};
  border-radius: 20px;
  height: 20px;
  width: 20;
  margin-left: 4px;
`;

export default ViewAllLink;
